var SignUpForm = Backbone.Epoxy.View.extend({

  template: 'modals.loginForm.signUpForm',
  bindings: 'data-bind',

  events: {
    'click .signin-link': 'signinLink',
    'click .submit-btn': 'register'
  },

  initialize: function() {
    this.model = bookedby.app.getCurrentClient();
  },

  signinLink: function() {
    bookedby.app.getCurrentClient().clearValidation();
    this.parent.toggleSigninForm();
  },

  register: function() {
    var clientModel = bookedby.app.getCurrentClient();
    if(clientModel.isValid(true)) {
      $.ajax({
        url: bookedby.routes.AUTHENTICATION.CREATE_AND_LOGIN,
        method: "POST",
        data: JSON.stringify( {
          client: clientModel,
          storeShortName: (bookedby.app.lastSelectedStore == null) ? null : bookedby.app.lastSelectedStore.shortName,
          storeGroupUuid: bookedby.staticData.storeGroupId
        }, function (key, value) {
          if (key == 'birthday') {
            return value ? moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD') : null;
          } else {
            return value;
          }
        }),
        contentType: "application/json",
        success: function(data) {
          if (!data.success) {
            if (data.userError) {
              alert(data.error);
            } else {
              bookedby.app.logAPIError(data.error);
            }
          } else if(!data.loggedIn) {
            bookedby.app.currentClient.set("email", data.email);
            var self = this;
            bookedby.app.showLogin(data.message, function() {
              self.onLoginSuccess();
            });
          } else {
            bookedby.app.currentClient.logIn({client: data});
            this.onLoginSuccess();
          }
        }.bind(this),
        error: _.bind(function(jqXHR, textStatus, textError) {
          bookedby.app.logAPIError(textError);
        }, this)
      });
    }
  },

  onLoginSuccess: function() {
    this.parent.$el.modal('hide');
    if(this.parent.callback) {
      this.parent.callback();
    }
  },

  afterRender: function() {
    this.applyBindings();
  },

  cleanup: function() {
    this.removeBindings();
  }

});


module.exports = SignUpForm;